<template>
	<v-tooltip top color="black">
		<template #activator="{ on, attrs }">
			<v-icon :color="cor" :size="tamanho" v-bind="attrs" v-on="on">
				{{ icone }}
			</v-icon>
		</template>
		<span>{{ texto }}</span>
	</v-tooltip>
</template>

<script>
export default {
	name: 'icone-tooltip',
	props: {
		cor: {
			type: String,
			default: 'primary',
		},
		icone: {
			type: String,
			default: '',
		},
		texto: {
			type: String,
			default: '',
		},
		tamanho: {
			type: String,
			default: '24px',
		},
	},
}
</script>

<style scoped></style>
